"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFileValidation = void 0;
const useFileValidation = (inputRef, options) => {
    const getSelectedFile = () => { var _a, _b; return ((_b = (_a = inputRef.value) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0]) || null; };
    const isFileSizeError = () => {
        var _a;
        if (!(options === null || options === void 0 ? void 0 : options.maxFileSizeMb))
            return false;
        return (((_a = getSelectedFile()) === null || _a === void 0 ? void 0 : _a.size) || 0) > options.maxFileSizeMb * 1000 * 1000;
    };
    const isFileTypeError = () => {
        var _a, _b;
        if (!inputRef.value.accept || !((_a = getSelectedFile()) === null || _a === void 0 ? void 0 : _a.type))
            return false;
        return !inputRef.value.accept.split(",").includes(((_b = getSelectedFile()) === null || _b === void 0 ? void 0 : _b.type) || "");
    };
    const getFormattedAcceptString = () => {
        var _a;
        return ((_a = inputRef.value) === null || _a === void 0 ? void 0 : _a.accept.split(",").map((format) => { var _a; return (_a = format.split("/").pop()) === null || _a === void 0 ? void 0 : _a.toUpperCase(); }).join(", ")) || "";
    };
    return { isFileSizeError, isFileTypeError, getFormattedAcceptString };
};
exports.useFileValidation = useFileValidation;
